const NonBreakingHyphenRule = ({ item }) => {
  if (typeof item?.teaserText === 'string') {
    const text = item.teaserText;

    const modifiedText = text.replace(
      /\[([^\]]*?)\]\(([^)]*?)\)|\b(net-a-porter|NET-A-PORTER|)\b/g,
      (match, linkText, linkHref, standaloneMatch) => {
        if (linkText && linkHref) {
          // It's a markdown link – update only the visible text
          const newLinkText = linkText.replace(/(net-a-porter|NET-A-PORTER)/g, m =>
            m.replace(/-/g, '\u2011')
          );
          return `[${newLinkText}](${linkHref})`;
        } else if (standaloneMatch) {
          // It's a standalone match – safe to replace
          return standaloneMatch.replace(/-/g, '\u2011');
        }
        return match;
      }
    );

    return {
      item: {
        ...item,
        teaserText: modifiedText
      }
    };
  }

  return { item };
};

export default NonBreakingHyphenRule;
